"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = exports.PRICE_STYLE_TYPE = exports.PRICE_SIZE = void 0;
Object.defineProperty(exports, "Tax", {
  enumerable: true,
  get: function () {
    return _Tax.Tax;
  }
});
Object.defineProperty(exports, "Value", {
  enumerable: true,
  get: function () {
    return _Value.Value;
  }
});
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Tax = require("./Tax");
var _Value = require("./Value");
require("./Price.scss");
let PRICE_SIZE = exports.PRICE_SIZE = /*#__PURE__*/function (PRICE_SIZE) {
  PRICE_SIZE["default"] = "default";
  PRICE_SIZE["small"] = "small";
  return PRICE_SIZE;
}({});
let PRICE_STYLE_TYPE = exports.PRICE_STYLE_TYPE = /*#__PURE__*/function (PRICE_STYLE_TYPE) {
  PRICE_STYLE_TYPE["default"] = "default";
  PRICE_STYLE_TYPE["discount"] = "discount";
  PRICE_STYLE_TYPE["secondary"] = "secondary";
  return PRICE_STYLE_TYPE;
}({});
const Price = _ref => {
  let {
    className,
    dataAttributes,
    currency,
    price,
    children = null,
    size = PRICE_SIZE.default,
    styleType = PRICE_STYLE_TYPE.default
  } = _ref;
  if (typeof price === 'undefined' || price === null) {
    return null;
  }
  const rootClassName = (0, _classnames.default)('cds-Price', {
    [`cds-Price--${(0, _upperCase.upperCaseFirst)(size || '')}`]: size !== PRICE_SIZE.default,
    [`cds-Price--${(0, _upperCase.upperCaseFirst)(styleType || '')}`]: styleType !== PRICE_STYLE_TYPE.default
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), /*#__PURE__*/_react.default.createElement(_Value.Value, {
    currency: currency,
    price: price
  }), children);
};
exports.Price = Price;
//# sourceMappingURL=Price.js.map